/* eslint-disable */
import React from "react";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const ProductDetailsCard = ({ product = {} }) => {
  return (
    <div className="product p-3 border border-gray-300 rounded-8 shadow-sm mt-3">
      <div className="d-flex gap-3">
        <img
          src={
            product?.productimagepath
              ? url.SERVER_URL + product?.productimagepath
              : assetImages.defaultUser
          }
          alt={product?.name}
          className="img border rounded-8 overflow-hidden"
          style={{
            width: "60px",
            height: "60px",
            objectFit: "cover",
          }}
        />
        <div>
          <p className="mb-0">{product?.name}</p>
          <p className="font-sm text-gray mb-1">{product?.producttypename}</p>
        </div>
      </div>
      <div className="benefit pt-3 border-top border-gray-100 mt-3">
        <p className="fw-semibold mb-2">Manufacturer</p>
        <p className="font-sm text-gray">{product?.companyname}</p>
      </div>
      <div className="side-effects pt-3 border-top border-gray-100 mt-3">
        <p className="fw-semibold mb-2">Summary</p>
        <p className="font-sm text-gray">{product?.summary}</p>
      </div>
      <div className="table-responsive pt-3 border-top border-gray-100 mt-3">
        <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
          <thead>
            <tr>
              <th className="fw-semibold">Weight (gm)</th>
              <th className="fw-semibold">Length (cm)</th>
              <th className="fw-semibold">Width (cm)</th>
              <th className="fw-semibold">Height (cm)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="font-sm text-gray">{product?.weight}</td>
              <td className="font-sm text-gray">{product?.length}</td>
              <td className="font-sm text-gray">{product?.width}</td>
              <td className="font-sm text-gray">{product?.height}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductDetailsCard;
